import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";

import cartReducer from "./slices/AddtoCartSlice";
import cartMutationReducer from "./slices/cartMutationSlice";
import checkoutReducer from "./slices/checkoutSlice";
import contentReducer from "./slices/contentSlice";
import credReducer from "./slices/cred/credSlice";
import menuReducer from "./slices/menuSlice";
import venuesReducer from "./slices/venueSlice";
import onlineOrderSettingsReducer from "./slices/onlineOrderSettingsSlice";

export const store = configureStore({
  reducer: {
    content: contentReducer,
    menu: menuReducer,
    venues: venuesReducer,
    cred: credReducer,
    cart: cartReducer,
    cartMutation: cartMutationReducer,
    checkout: checkoutReducer,
    onlineOrderSettings: onlineOrderSettingsReducer,

    [apiSlice.reducerPath]: apiSlice.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
